import { GenericWidget } from './generic';

export class Button extends GenericWidget {
    constructor(parameters) {
        super(parameters);
        this.onClick = parameters.onClick;
    }
}
